import { Observable } from "rxjs"
import PoolStatisticsDetails, { PoolStatisticsTestsGridData, PoolStatisticsTestsGridOptions } from "./RandomsModel/PoolStatisticsDetails"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function PoolStatisticsDetailsGetObservable(poolId: number, programId: number = 0, companyId?: number): Observable<PoolStatisticsDetails> {
  const requestBody: string = new URLSearchParams({
    poolId: poolId.toString(),
    companyId: (companyId || 0).toString(),
    programId: programId.toString(),
  }).toString();

  return ObservableFromFetch<PoolStatisticsDetails>("RandomTest/GetPoolStatisticsDetails?" + requestBody)
}

export function PoolStatisticsDetailsByProgram(poolId: number, poolProgramId?: number): Observable<PoolStatisticsDetails> {
  const requestBody: string = new URLSearchParams({
    poolId: poolId.toString(),
    poolProgramId: (poolProgramId || 0).toString()
  }).toString()

  return ObservableFromFetch<PoolStatisticsDetails>("RandomTest/PoolStatisticsDetailsByProgram?" + requestBody)
}

export function PoolStatisticsTestDetails(parameters: PoolStatisticsTestsGridOptions) {
  const requestBody: string = JSON.stringify(parameters)
  return ObservableFromFetch<PoolStatisticsTestsGridData>("RandomTest/GetPoolStatisticsTests", requestBody)
}

export function PoolStatisticsTestDetailsExport(parameters: PoolStatisticsTestsGridOptions) {
  const requestBody: string = JSON.stringify(parameters)
  return ObservableFromFetch<string>("RandomTest/ExportPoolStatisticsTests", requestBody)
}